import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@material-ui/core';
import { FlexCol, FlexGrowRow, FlexPaperCol, FlexRow } from '@xyo-network/sdk-xyo-react-js';
import numeral from 'numeral';
import { useContext } from 'react';
import { StatCardHeader, StatCardSummary } from '../../components';
import coinPile from '../../img/coin-pile.svg';
import { UserContext } from '../contexts';
import ProfileImageViewer from './ProfileImageViewer';
const Profile = (props) => {
    const { userInfo } = useContext(UserContext);
    const { username, activeSubscription } = userInfo !== null && userInfo !== void 0 ? userInfo : {};
    return (_jsxs(FlexPaperCol, Object.assign({ alignItems: "flex-start", busy: userInfo === undefined, style: {
            backgroundAttachment: 'cover',
            backgroundImage: `url(${coinPile})`,
            backgroundPositionX: 'right',
            backgroundPositionY: 'bottom',
            backgroundRepeat: 'no-repeat',
        } }, props, { children: [_jsxs(FlexRow, Object.assign({ justifyContent: "flex-start", style: { opacity: userInfo ? 1 : 0 } }, { children: [_jsxs(FlexCol, Object.assign({ margin: 2, marginRight: 0 }, { children: [_jsx(ProfileImageViewer, { variant: "outlined" }, void 0),
                            _jsx(Typography, Object.assign({ variant: "subtitle2" }, { children: ` (${activeSubscription})` }), void 0)] }), void 0),
                    _jsx(StatCardHeader, { title: `Hello @${username}!`, subtitle: "How much COIN will you earn today?" }, void 0)] }), void 0),
            _jsx(StatCardSummary, { title: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.xyoCollected) ? `${numeral(userInfo === null || userInfo === void 0 ? void 0 : userInfo.xyoCollected).format('0,0.00')} COIN balance` : '', value: userInfo === null || userInfo === void 0 ? void 0 : userInfo.xyoCollected }, void 0),
            _jsx(FlexGrowRow, {}, void 0)] }), void 0));
};
export default Profile;
